// @flow
import React from 'react';
import { Link } from 'react-router-dom';
import './EventActionButtons.scss';

type Props = {
  id: string,
  onAskRemove: () => void,
};

const EventActionButtons = ({ id, onAskRemove }: Props) => (
  <div className="EventActionButtons">
    <Link to={`/write?edit_id=${id}&type=event`} className="btn">
      수정
    </Link>
    <button className="btn" onClick={onAskRemove}>
      삭제
    </button>
  </div>
);

export default EventActionButtons;



// WEBPACK FOOTER //
// ./src/components/event/EventActionButtons/EventActionButtons.js